<template>
    <div
        :class="['dropdown-submenu', { 'dropdown-submenu-left': left, 'show': isOpen }]"
        @mouseenter="isOpen = true"
        @mouseleave="isOpen = false"
    >
        <slot/>
    </div>
</template>
<script>
export default {
    name: 'AppDropDownMenuSubmenu',
    provide() {
        return { navItem: this }
    },
    props: {
        left: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        close() {
            this.isOpen = false
        }
    }
}
</script>
